import { useSelector } from 'react-redux';
import { useCallback } from 'react';

import { selectServicePageInfo } from '../../../selectors/servicePageInfo';
import { createCianAnalyticsPageViewObject } from '../../../utils/createCianAnalyticsPageViewObject';
import { trackEvent } from '../../../utils/tracking';

export interface IUsePaymentTrackingResult {
  trackStatusChange: () => void;
  trackFinish: () => void;
  trackBeginAgain: () => void;
}

export const usePaymentTracking = (): IUsePaymentTrackingResult => {
  const servicePageInfo = useSelector(selectServicePageInfo);

  const trackStatusChange = useCallback<() => void>(() => {
    trackEvent({
      action: 'show',
      label: 'payment',
      ...createCianAnalyticsPageViewObject(servicePageInfo),
    });
  }, [servicePageInfo]);

  const trackFinish = useCallback<() => void>(() => {
    trackEvent({
      action: 'Click',
      label: 'thanks',
      ...createCianAnalyticsPageViewObject(servicePageInfo),
    });
  }, [servicePageInfo]);

  const trackBeginAgain = useCallback<() => void>(() => {
    trackEvent({
      action: 'Click',
      label: 'begin_again',
      ...createCianAnalyticsPageViewObject(servicePageInfo),
    });
  }, [servicePageInfo]);

  return {
    trackStatusChange,
    trackFinish,
    trackBeginAgain,
  };
};
